'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESOLVE_ATTACHMENTS = undefined;

var _createAsyncActionTypes = require('conversations-async-data/async-action/createAsyncActionTypes');

var RESOLVE_ATTACHMENTS = exports.RESOLVE_ATTACHMENTS = (0, _createAsyncActionTypes.createAsyncActionTypes)('RESOLVE_ATTACHMENTS');